const cloneDeep = <T extends {}>(arg: T): T => {
  return JSON.parse(JSON.stringify(arg))
}

export default cloneDeep
